import {getActiveUsers, getAllOxygenMappings} from '../app/selectors';
import {getOxygenEntityInfo} from './assigned-to-helpers';
import {HQ_USER_TYPE} from '../constants/hq-types';
import {PermissionsLevelsToIds, PermissionsResourceTypes, PermissionsV2TypeToValue} from '../constants/issues-admin';

const parsePermissionsLevels = levels =>
  levels && levels.length > 0
    ? levels
      .map(level => PermissionsLevelsToIds[level.name])
      .sort()
      .reduce((acc, level) => `${acc}${level}`)
    : '0';
const parseV2PermissionsActions = actions =>
  actions
    .map(action => PermissionsV2TypeToValue[action])
    .sort()
    .reduce((acc, action) => `${acc}${action}`);

const getProjectAdminUserIds = state =>
  getActiveUsers(state)
    .filter(user => user.isProjectAdmin)
    .map(user => user.id);

export const parseV1Permission = (rawPermission, state) => {
  const projectAdmins = getProjectAdminUserIds(state);
  const oxygen = getAllOxygenMappings(state);
  if (projectAdmins.includes(rawPermission.subject)) {
    return null;
  }

  const oxygenEntityInfo = getOxygenEntityInfo(oxygen, rawPermission.subjectType, rawPermission.subject);
  if (!oxygenEntityInfo) {
    return null;
  }
  return {
    name: oxygenEntityInfo.name,
    subjectId: oxygenEntityInfo.id,
    subjectType: rawPermission.subjectType,
    [rawPermission.resourceType]: {
      ...rawPermission,
      subject: oxygenEntityInfo,
      value: parsePermissionsLevels(rawPermission.levels)
    }
  };
};

export const parseV1Permissions = (rawPermissions, state) =>
  rawPermissions.map(p => parseV1Permission(p, state)).filter(Boolean);

export const parsePermission = (rawPermission, state) => {
  const projectAdmins = getProjectAdminUserIds(state);
  const oxygen = getAllOxygenMappings(state);
  const oxygenId = rawPermission.subject;
  const oxygenType = rawPermission.subjectType;
  const oxygenEntity = getOxygenEntityInfo(oxygen, oxygenType, oxygenId);

  if (!oxygenEntity) {
    return null;
  }

  const parsedPermission = {};

  parsedPermission.subjectId = oxygenId;
  parsedPermission.subjectType = oxygenType;
  parsedPermission.name = oxygenEntity.name;
  parsedPermission.isProjectAdmin = oxygenType === HQ_USER_TYPE && projectAdmins.includes(oxygenType);

  const value = parseV2PermissionsActions(rawPermission.actions.map(({name}) => name));
  parsedPermission[PermissionsResourceTypes.ISSUES] = {...rawPermission, subject: oxygenEntity, value};

  return parsedPermission;
};

export const parsePermissions = (rawPermissions, state) =>
  rawPermissions.map(p => parsePermission(p, state)).filter(Boolean);

export const parseBulkPermissionOperationSuccessResources = (rawPermissions, state) => {
  const projectAdmins = getProjectAdminUserIds(state);
  const oxygen = getAllOxygenMappings(state);

  return rawPermissions
    .map(rawPermission => {
      const oxygenId = rawPermission.subject;
      const oxygenType = rawPermission.subjectType;
      const oxygenEntity = getOxygenEntityInfo(oxygen, oxygenType, oxygenId);

      if (!oxygenEntity) {
        return null;
      }

      return {
        subjectId: oxygenId,
        subjectType: oxygenType,
        name: oxygenEntity.name,
        isProjectAdmin: oxygenType === HQ_USER_TYPE && projectAdmins.includes(oxygenType),
        [PermissionsResourceTypes.ISSUES]: {
          ...rawPermission,
          subject: oxygenEntity,
          value: parseV2PermissionsActions(rawPermission.actions)
        }
      };
    })
    .filter(Boolean);
};
